module.exports = __webpack_public_path__ + "static/media/urgent_filled_large.a95b512d.svg";